import React from 'react';
import { StyledButton } from '../styles';

const Button = ({ title, onClick, disabled, customStyle }) => {
  return (
    <StyledButton onClick={onClick} disabled={disabled} style={customStyle}>
      {title}
    </StyledButton>
  );
};

export default Button;
